var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderPfeilZuHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 25.667,
    viewBox: "0 0 35 25.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#039;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13 -4.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.674,0,240,1.6l15.443,16.074L240.009,33.387,241.665,35l17-17.313Z",
    transform: "translate(13 270) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.674,0,240,1.6l15.443,16.074L240.009,33.387,241.665,35l17-17.313Z",
    transform: "translate(13 263) rotate(-90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPfeilZuHover);
export default __webpack_public_path__ + "static/media/header-pfeil-zu-hover.f22f13d43eef8360e9cde525dd1ff981.svg";
export { ForwardRef as ReactComponent };